import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';

import { CatalogsModule } from '../catalogs/catalogs.module';
import { AccountsModule } from './accounts/accounts.module';
import { AddAccountModule } from './add-account/add-account.module';
import { AlcmeonAiModule } from './alcmeon-ai/alcmeon-ai.module';
import { SendByEmailSettingsComponent } from './company-contacts/send-by-email-settings/send-by-email-settings.component';
import { CrmOrganizationsModule } from './crm-organizations/crm-organizations.module';
import { CustomEventsModule } from './custom-events/custom-events.module';
import { ExternalAuthorizationsModule } from './external-authorizations/external-authorizations.module';
import { InMessageModule } from './in-message/in-message.module';
import { LinkShortenerModule } from './link-shortener/link-shortener.module';
import { MessageTemplatesModule } from './message-templates/message-templates.module';
import { SessionsModule } from './sessions/sessions.module';
import { SftpServersModule } from './sftp-servers/sftp-servers.module';
import { TrackLinkLabelsModule } from './track-link-labels/track-link-labels.module';
import { RandomDispatchActionComponent } from './triage/random-dispatch-action/random-dispatch-action.component';
import { RandomDispatchActionReadOnlyComponent } from './triage/random-dispatch-action/read-only/random-dispatch-action-read-only.component';
import { UsersModule } from './users/users.module';

@NgModule({
  imports: [CommonModule, SharedModule],
  exports: [
    AccountsModule,
    AddAccountModule,
    AlcmeonAiModule,
    CatalogsModule,
    CrmOrganizationsModule,
    CustomEventsModule,
    ExternalAuthorizationsModule,
    InMessageModule,
    LinkShortenerModule,
    MessageTemplatesModule,
    SessionsModule,
    SftpServersModule,
    TrackLinkLabelsModule,
    UsersModule,
  ],
  declarations: [RandomDispatchActionComponent, RandomDispatchActionReadOnlyComponent, SendByEmailSettingsComponent],
})
export class ParametersModule {}
